import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  medDomainEISBuildRowData: [],
};

export const medDomainEISSlice = createSlice({
  name: "medDomainEIS",
  initialState,
  reducers: {
    setMedDomainEISBuildRowData: (state, action) => {
      state.medDomainEISBuildRowData = action.payload;
    },
  },
});

export const { setMedDomainEISBuildRowData } = medDomainEISSlice.actions;
